import { ThemeOptions } from '@mui/material';

export const MuiListItemIcon: ThemeOptions['components']['MuiListItemIcon'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.secondary,
      minWidth: theme.spacing(5)
    })
  }
};
